<template>
  <div class="content">
    <div class="text-end mb-3">
      <select
        v-model="selectedLang"
        @change="onLangChange"
        class="form-select w-auto d-inline-block"
      >
        <option v-for="lang in languages" :key="lang.code" :value="lang.code">
          {{ lang.language }}
        </option>
      </select>
      <select
        v-model="selectedCountry"
        @change="onCountryChange"
        class="form-select w-auto d-inline-block"
      >
        <option value="" disabled>Select Country</option>
        <option
          v-for="count in countries"
          :key="count.code"
          :value="count.code"
        >
          {{ count.country }}
        </option>
      </select>
    </div>
    <div class="text-end mb-2">
      <button class="btn btn-success" @click="addPromotion">
        Add Promotion
      </button>
    </div>
    <div class="layout">
      <div>
        <!-- class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"> -->
        <div class="container-fluid">
          <div class="justify-content-center text-center">
            <div style="width: 100%">
              <div class="row">
                <div
                  class="col-md-4 mb-4"
                  v-for="(promo, index) in promotions"
                  :key="index"
                >
                  <div class="card h-100 shadow-sm">
                    <img
                      :src="getPromotionsUrl(promo.url)"
                      class="card-img-top"
                      alt="Promotion Image"
                      style="object-fit: cover; height: 200px"
                    />
                    <div class="card-body">
                      <h5 class="card-title">{{ promo.title }}</h5>
                      <h6 class="card-subtitle mb-2 text-muted">
                        {{ promo.name }}
                      </h6>
                      <h6
                        :class="
                          promo.status == 1
                            ? 'btn bg-success text-white'
                            : 'btn bg-danger text-white'
                        "
                      >
                        {{ promo.status == 1 ? "Active" : "Inactive" }}
                      </h6>

                      <p class="card-text" v-html="promo.description"></p>
                      <a
                        :href="promo.link"
                        target="_blank"
                        class="card-link text-white btn btn-green"
                        >{{ promo.btn_text }}</a
                      >
                    </div>
                    <div><p class="card-text" v-html="promo.terms"></p></div>

                    <div class="card-footer text-end bg-white border-top-0">
                      <button
                        class="btn btn-warning btn-sm mx-2"
                        @click="updatePromotionModel(promo)"
                      >
                        Update
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        @click="deletePromotion(promo.id)"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!promotions || promotions.length === 0"
                  class="col-12 text-center"
                >
                  <p>No Promotions found</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal for Adding Promotions -->
          <div v-show="showModal" class="modal">
            <div class="modal-content">
              <span
                class="close text-end text-danger"
                @click="showModal = false"
                >&times;</span
              >
              <h3>Add New Promotion</h3>
              <div class="mb-2">
                <input
                  type="text"
                  id="link"
                  v-model="link"
                  placeholder="Link"
                  class="form-control p-1 px-2"
                  required
                />
              </div>
              <div class="mb-2">
                <input
                  type="text"
                  id="title"
                  v-model="title"
                  placeholder="Title"
                  class="form-control p-1 px-2"
                  required
                />
              </div>
              <div class="mb-2 text-start">
                Status
                <select
                  id="status"
                  class="form-control p-1 px-2"
                  v-model="status"
                  required
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>

              <div class="mb-2">
                <input
                  type="text"
                  id="btnText"
                  v-model="btnText"
                  placeholder="Button Text"
                  class="form-control p-1 px-2"
                  required
                />
              </div>
              <input
                type="file"
                @change="onFileChange"
                class="form-control mb-2"
              />
              <!-- Description Editor -->
              <div class="col-md-12 mb-2">
                <label class="form-label text-black text-start"
                  >Description</label
                >
                <div
                  ref="editor"
                  class="ckeditor"
                  style="
                    height: 200px;
                    width: 100%;
                    border: 1px solid #ced4da;
                    padding: 10px;
                    border-radius: 0.375rem;
                  "
                ></div>
              </div>

              <!-- Terms Editor -->
              <div class="col-md-12 mb-2">
                <label class="form-label text-black text-start"
                  >Terms & Conditions</label
                >
                <div
                  ref="termsEditor"
                  class="ckeditor"
                  style="
                    height: 200px;
                    width: 100%;
                    border: 1px solid #ced4da;
                    padding: 10px;
                    border-radius: 0.375rem;
                  "
                ></div>
              </div>

              <div class="text-end mt-2">
                <button
                  class="btn btn-primary"
                  @click="submitPromotion"
                  :disabled="loading"
                >
                  <!-- Show spinner when loading is true -->
                  <span v-if="loading">loading...</span>
                  <!-- Show button text when not loading -->
                  <span v-else>Upload</span>
                </button>
              </div>
            </div>
          </div>

          <div v-show="showUpdateModal" class="modal">
            <div class="modal-content">
              <span
                class="close text-end text-danger"
                @click="showUpdateModal = false"
                >&times;</span
              >
              <h3>Update Promotion</h3>
              <div class="mb-2">
                <input
                  type="text"
                  id="link"
                  v-model="link"
                  placeholder="Link"
                  class="form-control p-1 px-2"
                  required
                />
              </div>
              <div class="mb-2">
                <input
                  type="text"
                  id="title"
                  v-model="title"
                  placeholder="Title"
                  class="form-control p-1 px-2"
                  required
                />
              </div>
              <div class="mb-2 text-start">
                Status
                <select
                  id="status"
                  class="form-control p-1 px-2"
                  v-model="status"
                  required
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <div class="mb-2 text-start">
                <input
                  type="file"
                  @change="onFileChange"
                  class="form-control mb-2"
                />
              </div>
              <div class="mb-2">
                <input
                  type="text"
                  id="btnText"
                  v-model="btnText"
                  placeholder="Button Text"
                  class="form-control p-1 px-2"
                  required
                />
              </div>
              <!-- Description Editor -->
              <div class="col-md-12 mb-2">
                <label class="form-label text-black text-start"
                  >Description</label
                >
                <div
                  ref="updateEditor"
                  class="ckeditor"
                  style="
                    height: 200px;
                    width: 100%;
                    border: 1px solid #ced4da;
                    padding: 10px;
                    border-radius: 0.375rem;
                  "
                ></div>
              </div>

              <!-- Terms Editor -->
              <div class="col-md-12 mb-2">
                <label class="form-label text-black text-start"
                  >Terms & Conditions</label
                >
                <div
                  ref="updateTermsEditor"
                  class="ckeditor"
                  style="
                    height: 200px;
                    width: 100%;
                    border: 1px solid #ced4da;
                    padding: 10px;
                    border-radius: 0.375rem;
                  "
                ></div>
              </div>

              <div class="text-end mt-2">
                <button
                  class="btn btn-primary"
                  @click="updatePromotion"
                  :disabled="loading"
                >
                  <!-- Show spinner when loading is true -->
                  <span v-if="loading">loading...</span>
                  <!-- Show button text when not loading -->
                  <span v-else>Update</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      quill: null,
      selectedLang: "en", // default language
      type: ["", "info", "success", "warning", "danger"],
      promotions: [], // Holds the list of promotions
      selectedImage: null, // Image file to be uploaded
      selectedPromo: null,
      showModal: false,
      showUpdateModal: false,
      loading: false,
      selectedLanguage: "",
      languages: [],
      selectedCountry: "CG",
      countries: [],
      prom: {
        active: 0,
      },

      link: "",
      title: "",
      description: "",
      terms: "",
      btnText: "",
      status: null,
      image: null,
    };
  },

  mounted() {
    this.initUpdateEditors();
    this.getLanguages();
    this.getCountries();

    // this.getPromotions(this.selectedLang, this.selectedCountry);
    this.quill = new Quill(this.$refs.editor, {
      theme: "snow",
      placeholder: "add description...",
    });
    this.quill.on("text-change", () => {
      this.description = this.quill.root.innerHTML;
    });

    this.quillTerms = new Quill(this.$refs.termsEditor, {
      theme: "snow",
      placeholder: "add terms & conditions...",
    });
    this.quillTerms.on("text-change", () => {
      this.terms = this.quillTerms.root.innerHTML;
    });
    if (!this.selectedCountry && this.countries.length) {
      this.selectedCountry = this.countries[0].code;
    }
  },
  watch: {
    selectedLang(newLang) {
      this.getPromotions(newLang, this.selectedCountry);
    },
    selectedCountry(newCountry) {
      this.getPromotions(this.selectedLang, newCountry);
    },
    showModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (!this.quill) {
            this.quill = new Quill(this.$refs.editor, {
              theme: "snow",
              placeholder: "add description...",
            });
            this.quill.on("text-change", () => {
              this.description = this.quill.root.innerHTML;
            });
          }
          if (!this.quillTerms) {
            this.quillTerms = new Quill(this.$refs.termsEditor, {
              theme: "snow",
              placeholder: "add terms & conditions...",
            });
            this.quillTerms.on("text-change", () => {
              this.terms = this.quillTerms.root.innerHTML;
            });
          }
        });
      }
    },
  },

  methods: {
    async getCountries() {
      try {
        const response = await axios.get(`countries`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;

          // 👇 ensure selected country exists
          if (
            !this.selectedCountry ||
            !this.countries.some((c) => c.code === this.selectedCountry)
          ) {
            this.selectedCountry = this.countries[0].code;
          }
        } else {
          this.countries = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async getLanguages() {
      try {
        const response = await axios.get(`languages`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        console.log(response);

        if (response.status == 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },

    initUpdateEditors() {
      this.updateQuill = new Quill(this.$refs.updateEditor, {
        theme: "snow",
        placeholder: "update description...",
      });
      this.updateQuill.on("text-change", () => {
        this.description = this.updateQuill.root.innerHTML;
      });

      this.updateQuillTerms = new Quill(this.$refs.updateTermsEditor, {
        theme: "snow",
        placeholder: "update terms & conditions...",
      });
      this.updateQuillTerms.on("text-change", () => {
        this.terms = this.updateQuillTerms.root.innerHTML;
      });
    },

    getPromotionsUrl(url) {
      if (url && !url.startsWith("https://")) {
        return `https://${url}`;
      }
      return url;
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file; // Store the selected file
      }
    },

    addPromotion() {
      this.showModal = true;
    },
    updatePromotionModel(promo) {
      this.showUpdateModal = true;
      this.selectedPromo = promo.id;
      this.link = promo.link;
      this.title = promo.title;
      this.btnText = promo.btn_text;
      this.status = promo.status;
      this.image = promo.url;

      this.$nextTick(() => {
        if (this.updateQuill) {
          this.updateQuill.root.innerHTML = promo.description || "";
        }
        if (this.updateQuillTerms) {
          this.updateQuillTerms.root.innerHTML = promo.terms || "";
        }
      });
    },
    initAddEditors() {
      this.quill = new Quill(this.$refs.editor, {
        theme: "snow",
        placeholder: "add description...",
      });
      this.quill.on("text-change", () => {
        this.description = this.quill.root.innerHTML;
      });

      this.quillTerms = new Quill(this.$refs.termsEditor, {
        theme: "snow",
        placeholder: "add terms & conditions...",
      });
      this.quillTerms.on("text-change", () => {
        this.terms = this.quillTerms.root.innerHTML;
      });
    },

    async submitPromotion() {
      // this.loading = true;
      if (!this.selectedImage) {
        this.$notify({
          message: "Select a promotion to upload",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        // this.loading = false;
        return;
      }

      const formData = new FormData();
      formData.append("file", this.selectedImage);
      formData.append("link", this.link);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("terms", this.terms);
      formData.append("btn_text", this.btnText);
      formData.append("language", this.selectedLang);
      formData.append("country", this.selectedCountry);
      formData.append("status", this.status);

      try {
        this.loading = true;

        const response = await axios.post("/promotions", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        if (response.status == 200) {
          this.loading = false;
          this.showModal = false;
          this.$notify({
            message: "Successfuly uploaded",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          window.location.reload();
          this.getPromotions(this.selectedLang, this.selectedCountry);
          this.resetForm();
        }
      } catch (error) {
        this.loading = false;

        if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "add_alert",
            horizontalAlign: "top",
            verticalAlign: "right",
            type: "danger",
          });
          Cookies.remove("authToken");
          this.$router.push("/login");
        } else if (error.status == 404) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    resetForm() {
      this.selectedImage = null;
      this.link = "";
      this.title = "";
      this.description = "";
      this.terms = "";
      this.btnText = "";
      this.status = null;
      if (this.quill) this.quill.setContents([]);
      if (this.quillTerms) this.quillTerms.setContents([]);
      this.showModal = false;
    },

    async getPromotions(lang, country) {
      try {
        const response = await axios.get(
          `/promotions?lang=${lang}&country=${country}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "api-key": `${Cookies.get("authToken")}`,
            },
          }
        );

        if (response.status == 200) {
          this.promotions = Array.isArray(response.data.promotions)
            ? response.data.promotions
            : [];

          // this.promotions = response.data.Promotions;
        }
      } catch (error) {
        if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          Cookies.remove("authToken");
          this.$router.push("/login");
        } else if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }

        console.error("Error fetching promotions:", error);
      }
    },
    onLangChange() {
      this.getPromotions(this.selectedLang, this.selectedCountry);
    },
    async deletePromotion(index) {
      try {
        this.loading = true;

        const response = await axios.delete(`promotions/${index}`, {
          headers: {
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        if (response.status == 200) {
          this.$notify({
            message: "Successfuly deleted",
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          window.location.reload();
          // this.getPromotions();
        }
      } catch (error) {
        this.loading = false;

        if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          Cookies.remove("authToken");
          this.$router.push("/login");
        } else if (error.status == 404) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
        console.error("Error deleting promotions", error);
      }
    },
    async updatePromotion() {
      // this.loading = true;
      if (!this.selectedPromo) {
        this.$notify({
          message: "Select a promotion to update",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        // this.loading = false;
        return;
      }

      const formData = new FormData();
      formData.append("file", this.selectedImage);
      formData.append("link", this.link);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("terms", this.terms);
      formData.append("btn_text", this.btnText);
      formData.append("language", this.selectedLang);
      formData.append("country", this.selectedCountry);
      formData.append("status", this.status);

      try {
        this.loading = true;

        const response = await axios.put(
          `/promotions/${this.selectedPromo}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "api-key": `${Cookies.get("authToken")}`,
            },
          }
        );

        if (response.status == 200) {
          this.loading = false;
          this.showModal = false;
          this.$notify({
            message: "Successfuly updated",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          window.location.reload();
          this.getPromotions(this.selectedLang, this.selectedCountry);
          this.resetForm();
        }
      } catch (error) {
        this.loading = false;

        if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "add_alert",
            horizontalAlign: "top",
            verticalAlign: "right",
            type: "danger",
          });
          Cookies.remove("authToken");
          this.$router.push("/login");
        } else if (error.status == 404) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
  },
};
</script>
<!-- <style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;

  top: 0px;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  width: 70%;
  margin-top: 30px;
  height: 90vh;
  display:flex ;
  justify-content: center;
  align-items: center;
}
.close {
  float: right;
  cursor: pointer;
}
</style> -->
<style scoped>
.modal {
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  width: 100%;
  max-width: 600px; /* ✅ Make modal smaller */
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  max-height: 90vh; /* Ensures dialog doesn't overflow viewport */
  position: relative;
}

.close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
}
.btn-green {
  background-color: green;
}
</style>
